var App = App || {};

App.OLBPromo = (function ($) {
    'use strict';

    function init() {
        if (!isEmpty($('.olb-promo-personalized > div'))) {
            $('.olb-promo-default').hide();
        }
        var findOlbpersonalized = $(".olb-promo-personalized").find(".personalized-olb");
        if (findOlbpersonalized != undefined && findOlbpersonalized != null && findOlbpersonalized.length > 0) {
            $('.olb-promo-default').hide();
        }
    }

    function isEmpty(el) {
        return !$.trim(el.html())
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.OLBPromo.init();
});